import React from 'react';

const DespachanteContext = React.createContext();

export default DespachanteContext;
